import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../../../environments/environment";
import {
    MaterializeAgentScanner, MaterializeScan, MaterializeScanData,
    MaterializeScanner,
    MaterializeScannersResponse
} from "../../impl/agent/materializeAgentScanner";
import {
    MaterializeAgentPlate,
    MaterializePlate,
    MaterializePlateDataPressureFragment,
    MaterializePlateFootPicture,
    MaterializePlateFootRawData,
    MaterializePlateResponse, MaterializePlatesResponse,
    MaterializePlateStaticRecording,
    MaterializePlateStreamingFrame, MaterializePlateSummary
} from "../../impl/agent/materializeAgentPlate";
import {ToastControl} from "../../../../../controls/core/toast/toast.control";
import * as forge from 'node-forge';

@Injectable()
export class MaterializeAgent {
    public readonly ERROR_NO_CONNECTED_PLATE = 'ERROR_NO_CONNECTED_PLATE';
    public readonly ERROR_NO_CONNECTED_SCANNER = 'ERROR_NO_CONNECTED_SCANNER';

    public static readonly API_BASE_URL = "http://localhost:16668/api";
    private static readonly base64PrivateKey = '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';

    private socket!: WebSocket;
    public token: string;
    private binaryDataProcessing = false;

    socketOnError$: Observable<boolean> = new BehaviorSubject(false);
    connected$: Observable<boolean> = new BehaviorSubject(false);
    connectionInProgress$: Observable<boolean> = new BehaviorSubject(false);

    // Plates
    plateLoading$: Observable<boolean> = new BehaviorSubject(false);
    plate$: Observable<MaterializePlate> = new BehaviorSubject(undefined);
    plateFootFound$: Observable<MaterializePlateFootPicture> = new BehaviorSubject(undefined);
    plateStreamingFrameFound$: Observable<MaterializePlateStreamingFrame> = new BehaviorSubject(undefined);
    staticRecordingResultFound$: Observable<MaterializePlateStaticRecording> = new BehaviorSubject(undefined);
    pressureMeasurementStateChanged$: Observable<PressureMeasurementStateChangedEvent> = new BehaviorSubject(undefined);

    // Scanner
    scanner$: Observable<MaterializeScanner> = new BehaviorSubject(undefined);
    scanStateChanged$: Observable<MaterializeScan> = new BehaviorSubject(undefined);

    constructor(private httpClient: HttpClient,
                private plateAgent: MaterializeAgentPlate,
                public scannerAgent: MaterializeAgentScanner,
                private toastControl: ToastControl) {

    }

    connect(url = "localhost:16667") {
        if (!this.socket) {
            (this.socketOnError$ as BehaviorSubject<boolean>).next(false);
            this.connectionInProgress = true;
            this.socket = new WebSocket("ws://"+ url + "/");

            this.socket.onerror = (error) => {
                console.error('WebSocket error:', error);
                (this.socketOnError$ as BehaviorSubject<boolean>).next(true);
            };

            this.socket.onclose = () => {
                this.connected = false;
                this.connectionInProgress = false;
                this.socket = undefined;
                this.token = undefined;
            };

            this.socket.onmessage = (event) => {
                let jsonData: any;
                let binaryData: any;
                try {
                    jsonData = JSON.parse(event.data);
                } catch (ex) {
                    binaryData = event.data;
                    // console.log(binaryData);
                }
                if (jsonData) {
                    // console.log(jsonData);
                    switch (jsonData.event) {
                        case 'connected':
                            this.token = jsonData.token;
                            // ('WebSocket connected');
                            this.socket.send(JSON.stringify({
                                event: 'login',
                                key: 'Prinsoles'
                            }));
                            break;
                        case 'authenticate':
                            this.socket.send(JSON.stringify({
                                event: 'authenticate',
                                response: this.sign(jsonData.challenge),
                            }));
                            break;
                        case 'authenticated': {
                            this.connected = true;
                            this.connectionInProgress = false;
                            this.refreshPlate();
                            this.refreshScanner();
                            break;
                        }
                        case 'pressurePlateStateChanged': {
                            const index = jsonData.index;
                            const state = jsonData.state;
                            const plate = this.plate;
                            if (plate.summary.id === index) {
                                plate.state = state;
                                this.plate = plate;
                            }
                            break;
                        }
                        case 'footFound': {
                            const name = jsonData.name;
                            const index = jsonData.index;
                            // this.fetchFootPressureRawData(name, index);
                            const currentPlate = this.plate;
                            if (currentPlate) {
                                this.plateAgent.fetchFootPressureImage(this.token, name, index, currentPlate).then((value) => this.plateFootFound = value);
                            }
                            break;
                        }
                        case 'pressureMeasurementStateChanged':
                            // console.log('pressureMeasurementStateChanged', jsonData);
                            (this.pressureMeasurementStateChanged$ as BehaviorSubject<PressureMeasurementStateChangedEvent>).next({
                                recordName: jsonData.name,
                                state: jsonData.state,
                                plate: this.plate
                            });
                            break;
                        case 'scannerStateChanged':
                            const scannerIndex = +jsonData.index;
                            const scannerState = jsonData.state;
                            if(this.scanner.id === scannerIndex) {
                                const scanner = this.scanner;
                                scanner.state = scannerState;
                                this.scanner = scanner;
                            }
                            break;
                        case 'scanStateChanged':
                            const scanName = jsonData.name;
                            const scanState = jsonData.state;
                            (this.scanStateChanged$ as BehaviorSubject<MaterializeScan>).next({
                                name: scanName,
                                state: scanState
                            });
                            break;
                    }
                } else if (binaryData) {
                    if (!this.binaryDataProcessing) {
                        this.binaryDataProcessing = true;
                        binaryData.arrayBuffer()
                            .then((arrayBuffer) => {
                                const dataView = new DataView(arrayBuffer);
                                const headerSize = dataView.getUint32(0, true); // false for big-endian
                                const headerBytes = new Uint8Array(arrayBuffer.slice(4, 4 + headerSize));

                                // Decode the header bytes to a JSON string
                                const headerJsonString = new TextDecoder("utf-8").decode(headerBytes);
                                const header = JSON.parse(headerJsonString);
                                // console.log('header', header);

                                const payload = arrayBuffer.slice(4 + headerSize);
                                // console.log("Payload Data:", payload, arrayBuffer.length, headerSize);

                                // Parse fragments
                                const fragmentView = new DataView(payload);
                                let offset = 0;
                                const fragments: MaterializePlateDataPressureFragment[] = [];
                                while (offset < payload.byteLength) {
                                    const x = fragmentView.getInt32(offset, true); // Little-endian
                                    offset += 4;

                                    const y = fragmentView.getInt32(offset, true);
                                    offset += 4;

                                    const width = fragmentView.getInt32(offset, true);
                                    offset += 4;

                                    const height = fragmentView.getInt32(offset, true);
                                    offset += 4;

                                    const pressureData = [];
                                    for (let row = 0; row < height; row++) {
                                        const rowData = [];
                                        for (let col = 0; col < width; col++) {
                                            const pressure = fragmentView.getFloat32(offset, true);
                                            offset += 4;
                                            rowData.push(pressure);
                                        }
                                        pressureData.push(rowData);
                                    }

                                    fragments.push({
                                        data: pressureData,
                                        height,
                                        width,
                                        y,
                                        x,
                                        plate: this.plate
                                    });
                                }
                                this.plateStreamingFrameFound = {
                                    measurementName: header.name,
                                    fragments,
                                }
                                this.binaryDataProcessing = false;
                            }).catch(() => this.binaryDataProcessing = false);
                    }
                }
            };

        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.close();
        }
    }

    private sign(challenge: string): string {
        try {
            // 1) Décoder le challenge (base64 -> binaire)
            const challengeBytes = forge.util.decode64(challenge);

            // 2) Reconstruire la clé privée en PEM (PKCS#1)
            const privateKeyPem = `-----BEGIN RSA PRIVATE KEY-----\n${MaterializeAgent.base64PrivateKey}\n-----END RSA PRIVATE KEY-----`;

            // 3) Parser la clé privée via forge
            const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);

            // 4) Calculer le hash SHA-512, puis signer
            const md = forge.md.sha512.create();
            md.update(challengeBytes);
            const signature = privateKey.sign(md);

            // 5) Retourner la signature encodée en Base64
            return forge.util.encode64(signature);

        } catch (error) {
            console.error('Erreur lors de la signature : ', error);
            throw new Error('Signing failed');
        }
    }

    // -------------------------- Plate ---------------------------------------------
    refreshPlate() {
        if (! this.socket) {
            this.connect();
        } else {
            this.plateLoading = true;
            this.plate = undefined;
            this.plateAgent.listPlates(this.token)
                .then((response: MaterializePlatesResponse) => {
                    if (response?.plates?.length > 0) {
                        this.plate = {
                            summary: {
                                id: response?.plates[0].id,
                                frameRate: response?.plates[0].frameRate,
                                sensorWidth: response?.plates[0].sensorWidth,
                                sensorHeight: response?.plates[0].sensorHeight,
                                brand: response?.plates[0].brand,
                                firmware: response?.plates[0].firmware,
                                licensed: response?.plates[0].licensed,
                                model: response?.plates[0].model,
                                width: response?.plates[0].width,
                                height: response?.plates[0].height,
                                serial: response?.plates[0].serial,
                            },
                            state: response.plates[0].state,
                        }
                    }
                })
                .finally(() => this.plateLoading = false);
        }
    }

    startPlateStaticRecording(name: string, durationInSeconds: number): Promise<void> {
        return new Promise((resolve, reject) => {
            const plate = this.plate;
            if (! plate) {
                reject(this.ERROR_NO_CONNECTED_PLATE);
            } else {
                return this.plateAgent.startPlateStaticRecording(name, this.token, plate.summary.id, durationInSeconds);
            }
        });
    }

    startPlateDynamicRecording(name: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const plate = this.plate;
            if (! plate) {
                reject(this.ERROR_NO_CONNECTED_PLATE);
            } else {
                return this.plateAgent.startPlateDynamicRecording(name, this.token, plate.summary.id);
            }
        });
    }

    stopPlateRecording(name: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const plate = this.plate;
            if (! plate) {
                reject(this.ERROR_NO_CONNECTED_PLATE);
            }
            this.httpClient.post<void>(MaterializeAgent.API_BASE_URL + '/v1/pressuremeasurements/'+ name + '/stop', {}, {
                headers: new HttpHeaders({
                    Authorization: `Bearer ${this.token}`
                })
            }).toPromise()
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    fetchFootPressureRawData(name: string,
                             index: number): Promise<MaterializePlateFootRawData> {
        return new Promise((resolve, reject) => {
            const currentPlate = this.plate;
            if (! currentPlate) {
                reject(this.ERROR_NO_CONNECTED_PLATE);
            }
            console.log('TOKEN ' + this.token);
            this.plateAgent.fetchFootPressureRawData(this.token, name, index, currentPlate)
                .then((value) => resolve(value));
        })
    }

    // ----------------------------- Scanner ---------------------------------------
    refreshScanner() {
        if (! this.socket) {
            this.connect();
        } else {
            this.scanner = undefined;
            this.scannerAgent.listScanners(this.token)
                .then((response: MaterializeScannersResponse) => {
                    if (response?.scanners?.length > 0) {
                        this.scanner = response?.scanners[0];
                    }
                });
        }
    }

    startScannerRecording(name: string,
                          side: 'left' | 'right',
                          lightSensitivity: 'VeryLow' | 'Low' | 'High' | 'VeryHigh' | 'Average'): Promise<void> {
        return new Promise((resolve, reject) => {
            const scanner = this.scanner;
            if (! scanner) {
                reject(this.ERROR_NO_CONNECTED_SCANNER);
            } else {
                return this.scannerAgent.startRecording(name, this.token, scanner.id, side, lightSensitivity);
            }
        });
    }

    retrieveScanData(name:string, format: 'stl' | 'obj'): Promise<MaterializeScanData> {
        return new Promise((resolve, reject) => {
            const scanner = this.scanner;
            if (! scanner) {
                reject(this.ERROR_NO_CONNECTED_SCANNER);
            } else {
                return this.scannerAgent.retrieveScanData(name, this.token, format)
                    .then((response: MaterializeScanData) => resolve(response))
                    .catch((e) => reject(e));
            }
        });
    }

    fetchFrames(recordingName: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.plateAgent.fetchFrames(this.token, recordingName, this.plate)
                .then((value) => {
                    this.staticRecordingResultFound = value;
                    resolve(undefined);
                })
                .catch((e) => reject(e));
        });
    }


    private set connectionInProgress(inProgress: boolean) {
        (this.connectionInProgress$ as BehaviorSubject<boolean>).next(inProgress);
    }

    private set connected(connected: boolean) {
        (this.connected$ as BehaviorSubject<boolean>).next(connected);
    }

    private set plate(plate: MaterializePlate) {
        (this.plate$ as BehaviorSubject<MaterializePlate>).next(plate);
    }

    private set plateLoading(loading: boolean) {
        (this.plateLoading$ as BehaviorSubject<boolean>).next(loading);
    }

    private get plate():MaterializePlate {
        return (this.plate$ as BehaviorSubject<MaterializePlate>).getValue();
    }

    private set plateFootFound(footData: MaterializePlateFootPicture) {
        (this.plateFootFound$ as BehaviorSubject<MaterializePlateFootPicture>).next(footData);
    }

    private set plateStreamingFrameFound(frame: MaterializePlateStreamingFrame) {
        (this.plateStreamingFrameFound$ as BehaviorSubject<MaterializePlateStreamingFrame>).next(frame);
    }

    private set scanner(scanner: MaterializeScanner) {
        (this.scanner$ as BehaviorSubject<MaterializeScanner>).next(scanner);
    }

    private get scanner(): MaterializeScanner {
        return (this.scanner$ as BehaviorSubject<MaterializeScanner>).getValue();
    }

    private get staticRecordingResultFound(): MaterializePlateStaticRecording {
        return (this.staticRecordingResultFound$ as BehaviorSubject<MaterializePlateStaticRecording>).getValue();
    }

    private set staticRecordingResultFound(staticRecordingResultFound: MaterializePlateStaticRecording) {
        (this.staticRecordingResultFound$ as BehaviorSubject<MaterializePlateStaticRecording>).next(staticRecordingResultFound);
    }

}

export class PressureMeasurementStateChangedEvent {
    state: string;
    recordName: string;
    plate: MaterializePlate;
}

